module.exports = require("moment-timezone");


//////////////////
// WEBPACK FOOTER
// external "moment-timezone"
// module id = 36
// module chunks = 0